import { PublicPaymentMethodPropertyCode } from '../enums/public-payment-method-property-code';

export class PublicPaymentMethodProperty {
  public constructor(
    private readonly data: {
      code: PublicPaymentMethodPropertyCode;
      name: string;
    },
  ) {}

  public get code(): PublicPaymentMethodPropertyCode {
    return this.data.code;
  }

  public get name(): string {
    return this.data.name;
  }
}
